import React, { useState, useEffect } from 'react';

// ✅ OTTIMIZZAZIONE: Importa solo i primi 2 loghi subito, altri lazy
import iconOpenAI from '../assets/logos/openai.svg';
import textOpenAI from '../assets/logos/openai-text.svg';
import iconGemini from '../assets/logos/gemini.svg';
import textGemini from '../assets/logos/gemini-text.svg';

// ✅ LAZY LOAD: Altri loghi caricano on-demand
const logoPairs = [
  { icon: iconOpenAI, text: textOpenAI, alt: 'OpenAI' },
  { icon: iconGemini, text: textGemini, alt: 'Gemini' },
  // ✅ Lazy loaded paths (importeranno solo quando necessario)
  { 
    icon: () => import('../assets/logos/perplexity.svg').then(m => m.default), 
    text: () => import('../assets/logos/perplexity-text.svg').then(m => m.default), 
    alt: 'Perplexity',
    lazy: true
  },
  { 
    icon: () => import('../assets/logos/claude.svg').then(m => m.default), 
    text: () => import('../assets/logos/claude-text.svg').then(m => m.default), 
    alt: 'Claude',
    lazy: true
  },
  { 
    icon: () => import('../assets/logos/copilot.svg').then(m => m.default), 
    text: () => import('../assets/logos/copilot-text.svg').then(m => m.default), 
    alt: 'Copilot',
    lazy: true
  },
  { 
    icon: () => import('../assets/logos/deepseek.svg').then(m => m.default), 
    text: () => import('../assets/logos/deepseek-text.svg').then(m => m.default), 
    alt: 'Deepseek',
    lazy: true
  },
  { 
    icon: () => import('../assets/logos/metaai.svg').then(m => m.default), 
    text: () => import('../assets/logos/metaai-text.svg').then(m => m.default), 
    alt: 'Meta AI',
    lazy: true
  },
];

const LogoRotator = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedLogos, setLoadedLogos] = useState({});

  // ✅ Pre-carica il logo successivo
  useEffect(() => {
    const nextIndex = (currentIndex + 1) % logoPairs.length;
    const nextPair = logoPairs[nextIndex];

    if (nextPair.lazy && !loadedLogos[nextIndex]) {
      // Carica in anticipo il prossimo logo
      Promise.all([
        typeof nextPair.icon === 'function' ? nextPair.icon() : Promise.resolve(nextPair.icon),
        typeof nextPair.text === 'function' ? nextPair.text() : Promise.resolve(nextPair.text)
      ]).then(([iconSrc, textSrc]) => {
        setLoadedLogos(prev => ({
          ...prev,
          [nextIndex]: { icon: iconSrc, text: textSrc }
        }));
      });
    }
  }, [currentIndex, loadedLogos]);

  // Rotazione ogni 3 secondi
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % logoPairs.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="logo-rotator-container">
      {logoPairs.map((pair, index) => {
        const isVisible = index === currentIndex;
        const loaded = pair.lazy ? loadedLogos[index] : pair;

        // ✅ Non renderizza se lazy e non ancora caricato
        if (pair.lazy && !loaded) {
          return null;
        }

        const iconSrc = loaded?.icon || pair.icon;
        const textSrc = loaded?.text || pair.text;

        return (
          <div
            key={pair.alt}
            className={`rotating-logo-pair ${isVisible ? 'visible' : ''}`}
          >
            <img 
              src={iconSrc} 
              alt="" 
              className="rotating-logo-icon"
              loading="lazy" // ✅ Lazy loading nativo
            />
            <img 
              src={textSrc} 
              alt={pair.alt} 
              className="rotating-logo-text"
              loading="lazy" // ✅ Lazy loading nativo
            />
          </div>
        );
      })}
    </div>
  );
};

export default LogoRotator;